import { useState } from 'react';

import { Row } from '@opendoor/atoms/box';
import { Button } from '@opendoor/atoms/button';
import { Text } from '@opendoor/atoms/text';
import { IconX } from '@tabler/icons-react';

import useQueryParams from '../../helpers/queryParams';

const MaintenanceBanner = () => {
  const { maintenance_start_time_local } = useQueryParams();
  const [showBanner, setShowBanner] = useState(maintenance_start_time_local !== undefined);
  const closeBanner = () => setShowBanner(false);

  if (!showBanner) return null;

  return (
    <Row className="justify-between bg-od-bg-error-secondary px-6 py-4">
      <Text as="p" className="grow text-center text-body-md font-medium md:text-body-lg">
        Opendoor will be down for scheduled maintenance on {maintenance_start_time_local}
      </Text>
      <Button
        aria-label="Close banner"
        size="sm"
        variant="secondary"
        onClick={closeBanner}
        id="maintenance-banner-close-button"
        analyticsName="cosmos-maintenance-banner-close"
        className="h-8 w-8 self-center rounded-full border-transparent bg-transparent p-0 hover:border-transparent hover:bg-transparent active:bg-transparent"
      >
        <IconX size={20} aria-hidden="true" />
      </Button>
    </Row>
  );
};

export default MaintenanceBanner;
